import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'DevicesPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13 19v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 17v5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 17v5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 9h2"
    }, null), _createTextVNode(" ")]);
  }
};